import { Controller } from "@hotwired/stimulus";
// import { post } from "@rails/request.js";

const vapidPublicKey = document.querySelector(
  'meta[name="vapid-public-key"]',
).content;

export const hasNotificationPermission = async () => {
  console.log(
    `Permission to receive notifications has been ${Notification.permission}`,
  );
  switch (Notification.permission) {
    case 'granted':
      return Promise.resolve(true);
    case 'denied':
      return Promise.resolve(false);
    default:
      const permission = await Notification.requestPermission();
      console.log(`Permission to receive notifications has been ${permission}`);
      return Promise.resolve(permission === 'granted');
  }
};

export const getRegistration = async () => navigator.serviceWorker.ready;

export const getSubscription = async () => {
  const registration = await getRegistration();

  return await registration.pushManager.getSubscription();
};

export const createSubscription = async () => {
  const registration = await getRegistration();

  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: vapidPublicKey,
  });

  return subscription;
};

export const unsubscribe = async () => {
  const subscription = await getSubscription();

  if (subscription) {
    // Unsubscribe if we have an existing subscription
    return await subscription.unsubscribe();
  } else {
    return Promise.resolve(false);
  }
};

export default class extends Controller {
  static targets = ['permissionsAsk'];

  async connect() {
    console.log("PWA Controller connected");

    if (!window.PushManager) {
      this.setError('Push messaging is not supported in your browser');
    }

    if (!ServiceWorkerRegistration.prototype.showNotification) {
      this.setError('Notifications are not supported in your browser');
      console.error('Push messaging is not supported in your browser');
    }

    const subscription = await getSubscription();

    if (subscription) {
      console.log('if (subscription) user');
      this.setStatusSubscribed(subscription);
    } else {
      this.resetSubscriptionStatus();
      this.trySubscribe()
    }

  }
  async trySubscribe() {
    console.log('trySubscribe');
    this.setError(null);

    let permissionGranted = await hasNotificationPermission();

    if (permissionGranted) {
      this.subscribe();
    } else {
      this.permissionDenied();
    }
  }

  async unsubscribe() {
    console.log('unsubscribe', 'start');
    const result = await unsubscribe();
    this.resetSubscriptionStatus();
    console.log('unsubscribe', 'finish', result);
  }

  async subscribe() {
    console.log('subscribe', 'start');
    
    const subscription =
      (await getSubscription()) || (await createSubscription());
    
    console.log('subscription', subscription)

    if (subscription) {
      this.setStatusSubscribed(subscription);
    } else {
      console.error('Web push subscription failed');
    }

    console.log('subscribe', 'finish', subscription);
  }

  async setStatusSubscribed(subscription) {
    const subscriptionData = subscription.toJSON();
    console.log('setSubscriptionStatusSubscribed', subscriptionData);

    // same user logs in again, after closing session badly (closing browser)
    

    const { response } = await fetch('/notifications/subscribe',
      {
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        method: "POST",
        body: JSON.stringify({ 
          subscribe: {
            endpoint: subscriptionData.endpoint,
            p256dh_key: subscriptionData.keys.p256dh,
            auth_key: subscriptionData.keys.auth,
          }
        }),
      });
    
    localStorage.setItem('endpoint', subscriptionData.endpoint)

    this.dispatch('subscription-changed', { detail: { subscription } });
  }

  resetSubscriptionStatus() {
    console.log('resetSubscriptionStatus');

    this.dispatch('subscription-changed', { detail: { subscription: null } });
  }

  permissionDenied() {
    console.log('permissionDenied');
    this.setError(
      'Permission for notifications is denied. Please change your browser settings if you wish to support web push.',
    );
    this.permissionsAskTarget.classList.remove("hidden");
  }

  setError(error) {
    if (error) console.error('setError', error);
    this.dispatch('subscription-error', { detail: { error } });
  }

}
